import { TransportType } from './transport-type';

export class TravelType {

    constructor(
        public id: number | null,
        public code: string,
        public transportType: TransportType,
        public description: string,
        public billingNote: string,
        public comment: string,
        public isActive: boolean,
        public longName?: string
    ){}
}
